import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap-button-loader";
import {
  checkTicketDaschoardStatus,
  fetchSettings,
  fetchWizardStep,
  fetchTickets,
  updateStripeAccount,
} from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";
import { fetchFormBuilder } from "FormBuilderAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { DEVELOPMENT_TYPE, COMMON_FAIL_MESSAGE } from "Constants";
import Navigation from "./navigation";
import Orzdetails from "./orzdetails";
import Publish from "./publish";
import Ticket from "Ticket";
import Schedules from "Schedules";
import EventPolicySetting from "EventPolicySetting";
import FormBuilder from "FormBuilder";
import LocaleStrings from "Languages";

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = { sessionShowenable: false };
  }

  componentDidMount() {
    this.props.checkTicketDaschoardStatus(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchSettings(this.props.session);
    this.props.fetchTickets(this.props.session);
    this.props.fetchFormBuilder(this.props.session, 0, (callback) => {});

    var url_string = window.location.href;
    var res = url_string.split("stripe_user_id=");
    if (res && res[1]) {
      this.updateStripeAccountData(res[1]);
    } else {
      this.props.fetchWizardStep("step_1");
    }

    var reser = url_string.split("error=");
    if (reser && reser[1]) {
      this.props.showError(reser[1]);
      this.props.fetchWizardStep("step_5");
    } else {
      this.props.fetchWizardStep("step_1");
    }
  }

  updateStripeAccountData(stripeaccountid) {
    this.props.updateStripeAccount(
      stripeaccountid,
      this.props.session,
      (response) => {
        //console.log('response',response);
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess("Stripe Details updated successfully!");
          this.props.fetchWizardStep("step_5");
        }
      }
    );
  }

  enableSession() {
    this.setState({ sessionShowenable: true });
  }

  proceedtoNextStep() {
    this.setState({ sessionShowenable: false });
    this.props.fetchWizardStep("step_5");
  }

  render() {
    let WizardStep = this.props.WizardStep;
    // console.log('WizardStep',WizardStep);
    let { deviceSize } = this.props;
    let contentDashboard = this.props.contentDashboard;

    let sessionShow =
      contentDashboard && contentDashboard.additionalsession
        ? contentDashboard.additionalsession
        : false;
    //console.log('sessionShow :- ', sessionShow)

    return (
      <div
        className="panel-body scrollable-content-full-page"
        style={{
          // height: deviceSize.height - 70,
          width: "100%",
        }}
      >
        <Navigation />
        {WizardStep == "step_1" ? (
          <div className="row m-0">
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <div className="p-0" style={{ width: "80%" }}>
                <label className="setting-company-buttons-section-heading">
                  {LocaleStrings.basic_setting_user_registration_group}
                </label>
                <hr className="hr-custom-new" />
                <EventPolicySetting />
              </div>
            )}
            <div className="col-md-12 p-0">
              <Orzdetails history={this.props.history} />
            </div>
          </div>
        ) : WizardStep == "step_2" ? (
          <Ticket history={this.props.history} />
        ) : WizardStep == "step_3" ? (
          <FormBuilder />
        ) : WizardStep == "step_4" ? (
          sessionShow || this.state.sessionShowenable ? (
            <Schedules history={this.props.history} source="ticket_wizard" />
          ) : (
            <div className="row">
              <div className="col-md-12">
                <label className="setting-company-section-heading">
                  {LocaleStrings.wizard_session_heading_text}
                </label>
                <hr className="hr-custom-new" />
                <span>{LocaleStrings.wizard_session_subheading_text1}</span>
                <br></br>
                <span>{LocaleStrings.wizard_session_subheading_text2}</span>
              </div>
              <div className="col-md-12">
                <div style={{ display: "flex" }}>
                  <Button
                    className="btn btn-custom-blue mt-10"
                    bsStyle=""
                    onClick={() => this.enableSession()}
                    type="button"
                  >
                    {LocaleStrings.wizard_session_enable}
                  </Button>
                  {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                  <Button
                    className="btn btn-custom-blue mt-10 ml-10"
                    bsStyle=""
                    onClick={() => this.proceedtoNextStep()}
                    type="button"
                  >
                    {LocaleStrings.wizard_session_skip}
                  </Button>
                </div>
              </div>
            </div>
          )
        ) : WizardStep == "step_5" ? (
          <Publish history={this.props.history} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    WizardStep: state.WizardStep,
    contentDashboard: state.contentDashboard.data,
    deviceSize: state.deviceSize,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchWizardStep,
    updateStripeAccount,
    showError,
    showSuccess,
    checkTicketDaschoardStatus,
    fetchSettings,
    fetchEventDetails,
    fetchTickets,
    fetchFormBuilder,
  })(Wizard)
);
